import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { AnalysisType } from "../../app/types/genericTables.types";

type UseAnalyisisType = {
  analysisTypeList: AnalysisType[];
  get: (id: AnalysisType["id"]) => AnalysisType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  fetchById: (id: number) => Promise<AnalysisType>;
  loading: boolean;
};

export const useAnalysisTypes = create<UseAnalyisisType>((set, get) => ({
  loading: false,
  analysisTypeList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().analysisTypeList.find((analysis) => analysis.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/TiposAnalisis";
      const { data: response } = await getData(endpoint);
      // Ordenar alfabéticamente por descripcion
      const sortedList = [...response].sort((a, b) =>
        a.descripcion.localeCompare(b.descripcion, 'es', { sensitivity: 'base' })
      );
      set(() => ({
        analysisTypeList: sortedList,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
  fetchById: async (id: number) => {
    set({ loading: true });
    try {
      const endpoint = `/generic/TiposAnalisis/filtered?id=${id}`;
      const { data: response } = await getData(endpoint);
      return response;
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
}));
